import React from "react";
import MaestroLoader from "@components/MaestroLoader";
import { Box, Button, CardCover, Grid, Typography } from "@mui/joy";
import TableWidget from "./layouts/TableWidget";
import { primaryProperty, useGetAllBusinesses } from "@api/businessService";
import ListWidget from "./layouts/ListWidget";
import { useGetProperty } from "@api/propertyService";
import ObjectPreview from "@components/objects/ObjectPreview";

const columns = [
    {
        id: 'name',
        numeric: false,
        disablePadding: true,
        sortable: true,
        label: 'Name',
        cell: (row, {LinkComponent}) => {
            return (<>
                <LinkComponent to={`/businesses/${row.id}`} object={row}>
                    <Typography sx={{display: 'inline-block'}} fontWeight={'bold'}>{row.name}</Typography>
                </LinkComponent>

                {row.dba_name && (<Typography fontSize="sm"><Typography fontWeight={'bold'}>DBA</Typography> {row.dba_name}</Typography>)}
            </>)
        }
    },
    {
        id: 'owner',
        numeric: false,
        disablePadding: false,
        sortable: false,
        label: 'Owner',
        cell: (row, {parentData, LinkComponent}) => {
            if(!row.owner) {
                return null;
            }

            // const primary = primaryProperty(row.business_locations);
            return (<Typography fontSize="sm"><LinkComponent to={`/contacts/${row.owner.id}`} object={row.owner}>{row.owner.name}</LinkComponent></Typography>)
        }
    },
];

export default function BusinessesAtPropertyWidget(props) {

    return (
        <ListWidget
            {...props}
            title={(data, parentData) => (<>Businesses at <ObjectPreview object={parentData} to={`/properties/${parentData.id}`}>{parentData.address}</ObjectPreview></>)}
            query={useGetProperty}
            relationship={'businesses'}
            include={'businesses,businesses.primary_contact'}
            columns={columns}
        />
    );
}
